import { ComponentDataSourceService } from '../../component-data-source.service';
import { DataSourceFunction } from '../../component-data-source.service';
import { EventParticipantDTO } from '../../../../dto/event/event-participant.dto';
import { createEventParticipantDataSource } from './event_participants';

export const event_instructors = (service: ComponentDataSourceService): DataSourceFunction =>
  createEventParticipantDataSource(service, {
    name: 'event_instructors',
    description: 'Get event instructors (excluding waitlist)',
    participantFilter: (participant: EventParticipantDTO) =>
      participant.status !== 'waitlist' && participant.role === 'instructor'
  });
